// ==============================|| OVERRIDES - SURFACES ||============================== //

export default function Surface(theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: theme.palette.background.paper,
          borderColor: theme.palette.divider
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        },
        outlined: {
          borderColor: theme.palette.divider
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          border: `1px solid ${theme.palette.divider}`
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: theme.palette.background.paper
        }
      }
    }
  };
}
